import React from "react";
import { TypeAnimation } from "react-type-animation";
import { Typography } from "@material-tailwind/react";
import { Element } from "react-scroll";

import sgFlag from "../../assets/sg_flag.jpg";
import SocialIcons from "../SocialIcons/SocialIcons";
import "./Home.css";

const Home = () => {
  return (
    <Element name="home">
      <div className="home-hero">
        <div className="home-content">
          <Typography variant="h1" className="home-greeting">
            Hi, I am Zheng Ting
          </Typography>
          <TypeAnimation
            sequence={[
              "a Software Engineer.",
              1000,
              "a Backend Developer.",
              1000,
              "a Full Stack Builder.",
              1000,
              "a continuous learner.",
              1000,
              "a problem solver.",
              1000,
            ]}
            wrapper="span"
            speed={50}
            repeat={Infinity}
            className="home-typing"
          />
          <Typography className="home-description">
            A Software Engineering undergraduate from Singapore. {" "}
            <img className="flag" src={sgFlag} alt="Singapore flag" />
          </Typography>
          <SocialIcons />
        </div>
        <div className="self-portrait self-portrait-home-size"></div>
      </div>
    </Element>
  );
};

export default Home;
